export function transformCategoriesForSelectObjArr(categories) {
  return categories?.map(({ id, name, categoryType }) => ({
    value: id,
    label: name,
    formType: categoryType,
  }));
}
